import { jsx as _jsx } from "react/jsx-runtime";
import { clsx } from "clsx";
import { forwardRef } from "react";
export const Select = forwardRef(function Select({ options, className, ...rest }, ref) {
    return (_jsx("select", { ref: ref, className: clsx("select", className), ...rest, children: options.map((opt) => (_jsx("option", { value: opt.value, children: opt.label }, opt.value))) }));
});
//# sourceMappingURL=Select.js.map